import { render } from "./MyFiles.vue?vue&type=template&id=f7a80380"
import script from "./MyFiles.vue?vue&type=script&lang=js"
export * from "./MyFiles.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ws\\me\\fast-file\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__